export default function jsonld(tag, data) {
  return {
    '@context': 'http://schema.org',
    '@type': tag,
    ...data,
  };
}
